import gk_highlights from "../../../blocks/Highlights/script";
import gk_accordions from "../../../blocks/AccordionTabs/script";
import gk_downloads from "../../../blocks/Download/script";
import gk_testimonyBlock from "../../../blocks/TestimonyBlock/script";
import gk_team from "../../../blocks/TeamBlock/script";
import gk_sld from "../../../blocks/SliderPage/script";
import gk_clientBlock from "../../../blocks/ClientBlock/script";
import gk_cptBlock      from "../../../blocks/CPTBlock/script";
import gk_timelineBlock  from "../../../blocks/TimelineBlock/script";
import gk_displayBlock   from "../../../blocks/DisplayBlock/script";
import gk_articleBlock   from "../../../blocks/ArticleBlock/script";
import gk_heroSlider     from "../../../blocks/HeroSlider/script";
import gk_videoBlock     from "../../../blocks/VideoBlock/script";
import gk_beforeAfterBlock from "../../../blocks/BeforeAfterBlock/script";
import gk_pricingBlock     from "../../../blocks/PricingBlock/script";

let gk_blocks = {
  load() {
    gk_highlights.load();
    gk_accordions.load();
    gk_downloads.load();
    gk_testimonyBlock.load();
    gk_team.load();
    gk_sld.load();
    gk_clientBlock.load();
    gk_cptBlock.load();
    gk_timelineBlock.load();
    gk_displayBlock.load();
    gk_articleBlock.load();
    gk_heroSlider.load();
    gk_videoBlock.load();
    gk_beforeAfterBlock.load();
    gk_pricingBlock.load();
  },
};
export default gk_blocks;
